/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Payments_Refund_ConfirmInputs */

const cs_deal_payments_refund_confirm = /** @type {(inputs: Deal_Payments_Refund_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Označit tuto platbu jako vrácenou? Záznam zůstane v historii.`)
};

const en_deal_payments_refund_confirm = /** @type {(inputs: Deal_Payments_Refund_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark this payment as refunded? The row stays in history.`)
};

/**
* | output |
* | --- |
* | "Mark this payment as refunded? The row stays in history." |
*
* @param {Deal_Payments_Refund_ConfirmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_payments_refund_confirm = /** @type {((inputs?: Deal_Payments_Refund_ConfirmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Payments_Refund_ConfirmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_payments_refund_confirm(inputs)
	return cs_deal_payments_refund_confirm(inputs)
});